import classNames from 'classnames';
import _ from 'lodash';
import { ToggleButton } from '@/shared/ui/components';
import './toggleInput.scss';
import type { ToggleInputProps } from './toggleInput.types';

/**
 * Segmented control rendering a list of options as toggle buttons. Maps props.options to ToggleButton elements marking the one matching props.value active, disables entries listed in disabledIndexes or every entry when the input is disabled, forwards clicks as a name and value pair, and shows the error message when isError.
 *
 * @param props - Option list, selected value, field name and label, disabled indexes and flags, error state and the change handler.
 * @returns The rendered toggle input element.
 */
const ToggleInput = (props: ToggleInputProps) => {
  const {
    className = undefined,
    name = '',
    label = '',
    disabled = false,
    isError = false,
    errorMessage = '',
  } = props;

  /**
   * Passes a toggle selection up to the form owner. Calls props.onChange with the changed field name and the selected value.
   *
   * @param changedName - Name of the field whose selection changed.
   * @param value - The newly selected option value.
   * @returns Nothing.
   */
  const onChange = (changedName: any, value: any) => {
    props.onChange(changedName, value);
  };

  return (
    <div className={classNames('custom-toggle-input', className)}>
      {!!label && <div className="custom-toggle-input__title">{label}</div>}
      <div className="flex">
        {_.map(props.options, (item, index) => (
          <ToggleButton
            key={index}
            className={classNames(
              'custom-toggle-input__list-item',
              disabled || _.includes(props.disabledIndexes, index) ? '--disabled' : '',
            )}
            name={name}
            data={item}
            isActive={item.value === props.value}
            onClick={onChange}
            disabled={disabled || _.includes(props.disabledIndexes, index)}
          />
        ))}
      </div>
      {isError && !!errorMessage && (
        <div className="custom-toggle-input__error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default ToggleInput;
